import Icon from '../components/Icon.vue'

Icon.register({
  coins: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M0 405.3c41.3 29.1 116.8 42.7 192 42.7s150.7-13.6 192-42.7v42.7c0 35.3-86 64-192 64s-192-28.7-192-64v-42.7zM320 128c-106 0-192-28.7-192-64s86-64 192-64 192 28.7 192 64-86 64-192 64zM0 300.4c41.3 34 116.9 51.6 192 51.6s150.7-17.6 192-51.6v51.6c0 35.3-86 64-192 64s-192-28.7-192-64v-51.6zM416 311.4v-63.6c38.7-6.9 72.8-18.1 96-34.5v42.7c0 23.7-38.7 44.3-96 55.4zM192 160c106 0 192 35.8 192 80s-86 80-192 80-192-35.8-192-80 86-80 192-80zM411.3 216.3c-8.8-23.7-30.5-42.9-60-57.2 64.2-3.2 125.2-16.7 160.7-41.8v42.7c0 24.3-40.7 45.5-100.7 56.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/coins.js
// module id = 1224
// module chunks = 0